// extracted by mini-css-extract-plugin
export var footerCommonStyles = "footer-module--footerCommonStyles--aY2ax";
export var footerBrandingStyles = "footer-module--footerBrandingStyles--zRqNT";
export var legalStyles = "footer-module--legalStyles--p0uXG";
export var copyrightStyles = "footer-module--copyrightStyles--Ge+xT";
export var privacyStyles = "footer-module--privacyStyles--OsbqD";
export var termsStyles = "footer-module--termsStyles--UVUhn";